<template>
  <div class="message">
    <div :class="message.type === 'user' ? 'dialog__user-wrapper' : 'dialog__bot-wrapper'">
      <div v-if="message.type === 'bot'" class="dialog__wrapper">
        <img src="@/assets/images/bot_avatar.png" class="avatar" />
        <div class="user-message" v-if="message.type === 'bot'">
          <p class="body body_size_M body_type_bold">Казатель GPT</p>
          <p class="label label_size_M" v-html="applyStyle(message.text)"></p>
          <Kaz-button
            title="Скопировать ответ"
            :label="''"
            :size="'M'"
            :leftIcon="true"
            :leftIconName="buttonIcon"
            :appearance="'flat'"
            @click="copyText"
          />
        </div>
      </div>
      <div v-if="message.type === 'user'" class="dialog__wrapper">
        <div v-if="sessionActive">
          <kaz-avatar :size="'XS'" :avatarImage="getSrcAvatar" class="avatar" @error="handleImageError"/>
        </div>
        <div v-else>
          <img src="@/assets/KazIllustrations/states/noAvatar.png" class="avatar" />
        </div>
        <div class="user-message" v-if="message.type === 'user'">
          <p class="body body_size_M body_type_bold">{{ getUserName }}</p>
          <p class="label label_size_M">{{ message.text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import KazAvatar from '@/components/KazUI/atoms/avatar'
import KazButton from '@/components/KazUI/atoms/button'

import { mapGetters } from 'vuex';

export default {
  name: 'message',
  components: {
    KazAvatar,
    KazButton
  },
  data() {
    return {
      buttonIcon: 'kuiIconCopyLarge',
    };
  },
  props: {
    message: {
      type: Object,
    },
  },
  methods: {
    handleImageError(event) {
      event.target.src = require('@/assets/images/profile-image-plug.png');
    },

    applyStyle(text) {
      text = text.replace(/\*\*(.*?)\*\*/g, '<span style="font-weight: 600; font-size: 16px;">$1</span>');
      text = text.replace(/\*(.*?)\*/g, '<span style="font-style: italic;">$1</span>');
      return text;
    },

    async copyText() {
      const originalText = this.message.text;
      const textToCopy = originalText.replace(/^\*{4}([\s\S]*)\*{4}$/, '$1').replace(/<br>/g, '').trim();

      try {
        await navigator.clipboard.writeText(textToCopy);
        this.buttonIcon = 'kuiIconCheckLarge';
        setTimeout(() => {
          this.buttonIcon = 'kuiIconCopyLarge';
        }, 3000);
      } catch (err) {
        console.error('Failed to copy text:', err);
      }
    },
  },
  computed: {
    ...mapGetters({
      getStudent: 'userData/getStudent',
      getSrcAvatar: 'userData/getSrcAvatar',
      sessionActive: 'authData/sessionActive',
    }),
    getUserName() {
      if(this.getStudent.firstName && this.getStudent.lastName){
        return `${this.getStudent.firstName} ${this.getStudent.lastName}` || 'Пользователь';
      }
      return 'Пользователь';
    },
  },
};
</script>

<style scoped>
.message:last-of-type{
  padding-bottom: 32px;
}
.dialog__wrapper{
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
}
.dialog__bot-wrapper{
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
}
.user-message{
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.avatar{
  width: 32px;
  height: 32px;
}
button{
  width: fit-content;
}
</style>
